import { useApolloFragment } from "apollo-fragment-react"

const SITE_CDN_INTEGRATIONS_FRAGMENT = `
    fragment SiteCdnIntegrationsFragment on Site {
      publishBranch
      cdnIntegrations {
        id
        siteId
        vendor
        connected
        config
      }
    }
`

export default function useSiteCdnIntegrations(siteId, branch = null) {
  const { data } = useApolloFragment(SITE_CDN_INTEGRATIONS_FRAGMENT, siteId)

  if (!data || !data.cdnIntegrations) {
    return []
  }

  if (branch && data.publishBranch !== branch) {
    return []
  }

  return data.cdnIntegrations
}
